module.exports = __webpack_public_path__ + "static/media/chikitsamitra.0f334442.png";